import dayjs from 'dayjs'
import dayjszh from 'dayjs/locale/zh-cn'
import relativeTime from 'dayjs/plugin/relativeTime'
import weekday from 'dayjs/plugin/weekday'
dayjs.extend(relativeTime)
dayjs.extend(weekday)
dayjs.locale(dayjszh)

/**
 * 生成ID
 * @return {string} id
 */
export const GetRndStringNum = (number = 8) => {
  const str = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  let id = ''
  for (let i = 0; i < number; i++) {
    id += str.charAt(Math.floor(Math.random() * str.length))
  }
  return id
}
/**
 * 时间格式转换
 */
export const FormatTime = (time = '', formatString = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(time).format(formatString)
}
/**
 * url解析
 */
export const GetModelName = (url) => {
  var theRequest = {}
  if (url.indexOf('?') !== -1) {
    var str = url.substr(1)
    let strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}
